import { css } from 'styled-components';

export const BurgerStyle = css`
  .burger-menu {
    padding: 0 8px;
    display: inline-block;
    overflow: visible;
    text-transform: none;
    color: inherit;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }

    &--outer,
    &--inner,
    &--inner::before,
    &--inner::after {
      transition-duration: 0.15s;
      transition-timing-function: linear;
      transition-property: all;
    }

    &--outer {
      position: relative;
      padding: 0;
      display: inline-block;
      width: 26px;
      height: 26px;
      background-color: transparent;
      border: 0;
      outline: 0;
    }

    &--inner,
    &--inner::before,
    &--inner::after {
      position: absolute;
      display: block;
      width: 100%;
      height: 1px;
      background-color: #c2c5cc;
      border-radius: 5px;
    }

    &--inner {
      top: 50%;

      &::before,
      &::after {
        content: '';
      }

      &::before {
        top: -7px;
      }

      &::after {
        bottom: -7px;
      }
    }

    &--expanded {
      .burger-menu--outer {
        transform: rotate(45deg);
      }

      .burger-menu--inner {
        &::before {
          opacity: 0;
        }

        &::after {
          bottom: 0;
          transform: rotate(90deg);
        }
      }
    }

    &--in-widget {
      margin-top: 0;
    }

    &--with-tabs {
      margin-top: 23.5px;
    }
  }
`;
